// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* BASE TOKENS */

  --base-size-0: 0rem;
  --base-size-2: 0.125rem;
  --base-size-4: 0.25rem;
  --base-size-6: 0.375rem;
  --base-size-8: 0.5rem;
  --base-size-10: 0.625rem;
  --base-size-12: 0.75rem;
  --base-size-14: 0.875rem;
  --base-size-16: 1rem;
  --base-size-20: 1.25rem;
  --base-size-24: 1.5rem;
  --base-size-32: 2rem;
  --base-size-40: 2.5rem;
  --base-size-48: 3rem;
  --base-size-56: 3.5rem;
  --base-size-64: 4rem;
  --base-size-72: 4.5rem;
  --base-size-80: 5rem;

  /* FUNCTIONAL TOKENS */

  /* Border Radius */
  --borderRadius-xsmall: 0.1875rem;
  --borderRadius-small: var(--base-size-4);
  --borderRadius-medium: var(--base-size-6);
  --borderRadius-large: var(--base-size-8);
  --borderRadius-xlarge: var(--base-size-12);
  --borderRadius-full: 624.9375rem;

  /* Border Width */
  --borderWidth-thin: max(1px, 0.0625rem);
  --borderWidth-thick: max(2px, 0.125rem);

  /* Spacing */
  --space-0: var(--base-size-0);
  --space-025: var(--base-size-2);
  --space-050: var(--base-size-4);
  --space-075: var(--base-size-6);
  --space-100: var(--base-size-8);
  --space-125: var(--base-size-10);
  --space-150: var(--base-size-12);
  --space-200: var(--base-size-16);
  --space-250: var(--base-size-20);
  --space-300: var(--base-size-24);
  --space-400: var(--base-size-32);
  --space-500: var(--base-size-40);
  --space-600: var(--base-size-48);
  --space-800: var(--base-size-64);
  --space-1000: var(--base-size-80);

  /* Breakpoints */
  --breakpoint-xsmall: 30rem;
  --breakpoint-small: 48rem;
  --breakpoint-medium: 64rem;
  --breakpoint-large: 90rem;
  --breakpoint-xlarge: 110rem;

  /* COMPONENT TOKENS */

  /* control */
  --control-large-gap: 0rem;
  --control-large-line-box-height: 0rem;
  --control-large-padding-block: 0rem;
  --control-large-base-size: var(--base-size-24);
  --control-medium-gap: 0rem;
  --control-medium-line-box-height: 0rem;
  --control-medium-padding-block: 0rem;
  --control-medium-base-size: var(--base-size-24);
  --control-small-gap: 0rem;
  --control-small-line-box-height: 0rem;
  --control-small-padding-block: 0rem;
  --control-small-base-size: var(--base-size-24);
}
`, "",{"version":3,"sources":["webpack://./public/styles/size.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;;EAEhB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;;EAEpB,sBAAsB;;EAEtB,kBAAkB;EAClB,gCAAgC;EAChC,wCAAwC;EACxC,yCAAyC;EACzC,wCAAwC;EACxC,0CAA0C;EAC1C,gCAAgC;;EAEhC,iBAAiB;EACjB,uCAAuC;EACvC,uCAAuC;;EAEvC,YAAY;EACZ,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;;EAEjC,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;;EAE3B,qBAAqB;;EAErB,YAAY;EACZ,yBAAyB;EACzB,qCAAqC;EACrC,mCAAmC;EACnC,8CAA8C;EAC9C,0BAA0B;EAC1B,sCAAsC;EACtC,oCAAoC;EACpC,+CAA+C;EAC/C,yBAAyB;EACzB,qCAAqC;EACrC,mCAAmC;EACnC,8CAA8C;AAChD","sourcesContent":[":root {\n  /* BASE TOKENS */\n\n  --base-size-0: 0rem;\n  --base-size-2: 0.125rem;\n  --base-size-4: 0.25rem;\n  --base-size-6: 0.375rem;\n  --base-size-8: 0.5rem;\n  --base-size-10: 0.625rem;\n  --base-size-12: 0.75rem;\n  --base-size-14: 0.875rem;\n  --base-size-16: 1rem;\n  --base-size-20: 1.25rem;\n  --base-size-24: 1.5rem;\n  --base-size-32: 2rem;\n  --base-size-40: 2.5rem;\n  --base-size-48: 3rem;\n  --base-size-56: 3.5rem;\n  --base-size-64: 4rem;\n  --base-size-72: 4.5rem;\n  --base-size-80: 5rem;\n\n  /* FUNCTIONAL TOKENS */\n\n  /* Border Radius */\n  --borderRadius-xsmall: 0.1875rem;\n  --borderRadius-small: var(--base-size-4);\n  --borderRadius-medium: var(--base-size-6);\n  --borderRadius-large: var(--base-size-8);\n  --borderRadius-xlarge: var(--base-size-12);\n  --borderRadius-full: 624.9375rem;\n\n  /* Border Width */\n  --borderWidth-thin: max(1px, 0.0625rem);\n  --borderWidth-thick: max(2px, 0.125rem);\n\n  /* Spacing */\n  --space-0: var(--base-size-0);\n  --space-025: var(--base-size-2);\n  --space-050: var(--base-size-4);\n  --space-075: var(--base-size-6);\n  --space-100: var(--base-size-8);\n  --space-125: var(--base-size-10);\n  --space-150: var(--base-size-12);\n  --space-200: var(--base-size-16);\n  --space-250: var(--base-size-20);\n  --space-300: var(--base-size-24);\n  --space-400: var(--base-size-32);\n  --space-500: var(--base-size-40);\n  --space-600: var(--base-size-48);\n  --space-800: var(--base-size-64);\n  --space-1000: var(--base-size-80);\n\n  /* Breakpoints */\n  --breakpoint-xsmall: 30rem;\n  --breakpoint-small: 48rem;\n  --breakpoint-medium: 64rem;\n  --breakpoint-large: 90rem;\n  --breakpoint-xlarge: 110rem;\n\n  /* COMPONENT TOKENS */\n\n  /* control */\n  --control-large-gap: 0rem;\n  --control-large-line-box-height: 0rem;\n  --control-large-padding-block: 0rem;\n  --control-large-base-size: var(--base-size-24);\n  --control-medium-gap: 0rem;\n  --control-medium-line-box-height: 0rem;\n  --control-medium-padding-block: 0rem;\n  --control-medium-base-size: var(--base-size-24);\n  --control-small-gap: 0rem;\n  --control-small-line-box-height: 0rem;\n  --control-small-padding-block: 0rem;\n  --control-small-base-size: var(--base-size-24);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
